import SearchBox from "@/common/SearchBox";
import { LayoutHeader } from "@/Header";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useState } from "react";
import { useBusinessMypageContractList } from "~/services/business/myPage";

export const Route = createFileRoute(
  "/business/layout/user-contract-managementOld"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { history } = useRouter();
  const [searchKeyword, setSearchKeyword] = useState<string>("");
  // const [isSearchTriggered, setIsSearchTriggered] = useState<boolean>(false);
  const [currentSearchKeyword, setCurrentSearchKeyword] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);

  // API 파라미터 설정
  const apiParams = {
    searchKeyword: currentSearchKeyword,
    page: currentPage,
    size: pageSize,
  };

  // 계약 목록 API 호출
  const { data: contractListData } = useBusinessMypageContractList(apiParams);

  const handleSearch = (keyword: string) => {
    setCurrentSearchKeyword(keyword);
    setCurrentPage(1); // 검색 시 첫 페이지로 이동
    // setIsSearchTriggered(true);
  };
  console.log(contractListData?.data.content);
  return (
    <>
      <LayoutHeader title={"계약 관리"} hasBackBtn hasFootPrint={false} />
      <div className="flex-auto bg-[#F5F5F5] min-h-[87.8vh]">
        {/* 서치박스 */}
        <div className="mx-2">
          <div className="flex justify-end items-center px-2 py-3">
            <SearchBox
              searchText={searchKeyword}
              setSearchText={setSearchKeyword}
              onSearch={handleSearch}
              placeholder="반려동물 이름 또는 보호자 닉네임으로 검색"
            />
          </div>
        </div>
        {/* 총 계약 수 */}
        <div className="flex gap-2 items-center pl-1 mx-4 mb-2">
          <div className="text-[14px] font-semibold">
            총 {contractListData?.data.totalElements || 0}마리
          </div>
          <div className="text-[13px] text-[#999999]">|</div>
          <div className="text-[13px] text-[#999999]">
            반려동물의 수로 집계됩니다.
          </div>
        </div>
        <div className="grid grid-cols-10 gap-2 items-center mx-4 mb-2">
          <div className="col-span-2 text-[14px] text-[#666666] text-center">
            고객명
          </div>
          <div className="col-span-2 text-[13px] text-[#666666] text-center">
            반려동물
          </div>
          <div className="col-span-3 text-[14px] text-[#666666] text-center">
            계약일
          </div>
          <div className="col-span-2 text-[13px] text-[#666666] text-center">
            종료일
          </div>
        </div>
        {/* 계약 목록 */}
        {contractListData?.data.content.map((contract) => (
          <div
            className="grid grid-cols-10 gap-2 items-center mx-4 mb-2 bg-white rounded-lg border border-[#e9e9e9] h-[50px]"
            key={contract.histContrSeq}
            onClick={() =>
              history.push(
                `/business/layout/user-contract-detail?histContrSeq=${contract.histContrSeq}`
              )
            }
          >
            <div className="col-span-2 text-[14px] text-[#666666] text-center">
              {contract.userName}
            </div>
            <div className="col-span-2 text-[13px] text-[#666666] text-left  overflow-hidden text-ellipsis whitespace-nowrap">
              {contract.petName}
            </div>
            <div className="col-span-3 text-[14px] text-[#666666] text-center">
              {contract.startContractDate}
            </div>
            <div className="col-span-3 text-[13px] text-[#666666] text-center">
              {contract.endContractDate}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
